import { SvgIcon } from '@mui/material'

export default function IconArrowDown () {
  return (
      <SvgIcon sx={{
        width: 12,
        ml: '6px',
        mb: '1px'
      }}>
          <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.75 3.375L4.5 5.625L2.25 3.375" stroke="#7D8FB3" strokeLinecap="round"
                    strokeLinejoin="round"/>
          </svg>
      </SvgIcon>
  )
}
